export class RenderImage {
    static loadImageSettingsCheck(container: HTMLElement, images: HTMLElement[]) {
        const dimensionsElements: any = [];
        images.forEach(async (company: HTMLElement) => {
            await this.settingSizesStyleClasses(
                container,
                images,
                company,
                dimensionsElements,
            );
        });
    }

    private static async settingSizesStyleClasses(
        container: HTMLElement,
        images: HTMLElement[],
        company: HTMLElement,
        dimensionsElements: any[]
    ) {
        const url: string | null | undefined = company.querySelector('img')?.getAttribute('src');
        const img: HTMLImageElement = new Image();
        const grayTiles: HTMLElement[] = images;
        const getMaxOfArray = (numArray: number[]) => {
            return Math.max.apply(null, numArray);
        }

        img.onload = async () => {
            dimensionsElements.push(company.getBoundingClientRect().width);

            if (dimensionsElements.length === grayTiles.length) {
                dimensionsElements.forEach((dimensionsElement, index) => {
                    grayTiles[index].style.width = `${getMaxOfArray(dimensionsElements)}px`
                    grayTiles[index].classList.add('active')
                });
                container.classList.add('hidden');
            }
        };
        img.onerror = function() {
            console.error(`Ошибка при загрузке изображения ${url}`);
        };
        if (url) {
            img.src = url;
        }
    }
}
